import { VStack as ChakraVStack } from "@chakra-ui/react";
import { type StackProps } from "./Stack.web";

export default function VStack({
  spacing,
  gap,
  ...props
}: StackProps): JSX.Element {
  // In Chakra v3, 'spacing' is replaced by 'gap'
  // We maintain backward compatibility by accepting 'spacing' and mapping it to 'gap'
  const gapValue = gap !== undefined ? gap : spacing;

  return <ChakraVStack gap={gapValue} {...props} />;
}
